import './timeline.css';
import timelineBg from './timeline.png';
import timelineBgSm from './timeline_small.png';
export const Timeline = () => {
    return (
        <>
        <h3>Stage 1</h3>
        <ul className="timeline" style={{background: `url(${timelineBg})`, backgroundRepeat: "no-repeat", backgroundPositionX: "center", backgroundPositionY: "80px", backgroundSize: "16px 92%"}}>
            <li className='centered-item' data-aos="fade-up">
                <div className="timeline-date">Q3 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Smart Contracts Creation</h2>
                    </div>
                </div>
            </li>
            <li className='left-item' data-aos="fade-up">
                <div className="timeline-date">Q3 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Economic rights transference to RBY Tokens supply</h2>
                    </div>
                </div>
            </li>
            <li className='right-item' data-aos="fade-up">
                <div className="timeline-date">Q3 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Legal Terms defined</h2>
                    </div>
                </div>
            </li>
            <li className='left-item' data-aos="fade-up">
                <div className="timeline-date">Q3 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>World top expert updated official appraisal of the stone published</h2>
                    </div>
                </div>
            </li>
            <li className='right-item' data-aos="fade-up">
                <div className="timeline-date">Q3 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Website Launch</h2>
                    </div>
                </div>
            </li>
            <li className='left-item' data-aos="fade-up">
                <div className="timeline-date">Q3 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Whitelist opening</h2>
                    </div>
                </div>
            </li>
            <li className='right-item' data-aos="fade-up">
                <div className="timeline-date">Q3 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Twitter, Discord and Instagram official Launch</h2>
                    </div>
                </div>
            </li>
            <li className='left-item' data-aos="fade-up">
                <div className="timeline-date">Q3 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Unveil of certain details of the NFT design</h2>
                    </div>
                </div>
            </li>
            <li className='right-item' data-aos="fade-up">
                <div className="timeline-date">Q4 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>LAUNCH OF 20,000 UNIQUE REAL ASSET BACK NFTs</h2>
                    </div>
                </div>
            </li>
            <li className='left-item' data-aos="fade-up">
                <div className="timeline-date">Q4 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>DeFi: Staking & Community Pool</h2>
                    </div>
                </div>
            </li>
            <li className='right-item' data-aos="fade-up">
                <div className="timeline-date">Q4 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Donation to NGOs presented and process activation</h2>
                    </div>
                </div>
            </li>
            <li className='left-item' data-aos="fade-up">
                <div className="timeline-date">Q4 2022</div>
                <div className="timeline-panel">
                    <div className="timeline-heading">
                        <h2>Rewards Mechanism Activation</h2>
                    </div>
                </div>
            </li>
          </ul>
            <h3>Stage 2</h3>
            <ul className="timeline">
                <li className='centered-item' data-aos="fade-up">
                    <div className="timeline-date">2023</div>
                    <div className="timeline-panel">
                        <div className="timeline-heading">
                            <h2>First artists colaborations announcements</h2>
                        </div>
                    </div>
                </li>
            </ul>
            <img src={timelineBgSm} style={{width:"16px"}} alt="timeline"/>
            <h3>Stage 3</h3>
            <ul className="timeline">
                <li className='centered-item' data-aos="fade-up">
                    <div className="timeline-date">2023</div>
                    <div className="timeline-panel">
                        <div className="timeline-heading">
                            <h2>Rubybuddy</h2>
                        </div>
                    </div>
                </li>
            </ul>
          </>
    )
}